import type { DataScope, Role } from '../../shared/types/domain';

export const actions = [
  'member.read', 'member.create', 'member.update',
  'order.create.standard', 'order.submit.exception', 'order.approve', 'refund.submit', 'refund.approve',
  'schedule.create', 'schedule.cancel', 'lesson.checkIn', 'lesson.consume', 'lesson.reverse', 'lesson.reverse.approve',
  'feedback.publish', 'rating.create',
  'star.claim', 'star.review', 'star.rule.manage',
  'mall.redeem', 'mall.item.manage', 'inventory.adjust',
  'account.member.create', 'account.employee.create', 'account.employee.update', 'account.restore', 'account.disable',
  'delegation.manage', 'store.manage', 'audit.read', 'export.sensitive',
] as const;

export type Action = (typeof actions)[number];

const roleScopes: Record<Role, DataScope[]> = {
  member: ['self'],
  employee: ['self', 'assigned', 'delegated'],
  manager: ['self', 'store'],
  super: ['self', 'company'],
};

const grants: Record<Role, Action[]> = {
  member: ['member.read', 'schedule.cancel', 'rating.create'],
  employee: ['member.read', 'member.create', 'member.update', 'account.member.create', 'order.create.standard', 'order.submit.exception', 'refund.submit', 'schedule.create', 'schedule.cancel', 'lesson.checkIn', 'lesson.consume', 'lesson.reverse', 'feedback.publish', 'star.claim', 'mall.redeem'],
  manager: ['member.read', 'member.create', 'member.update', 'account.member.create', 'order.create.standard', 'order.submit.exception', 'order.approve', 'refund.submit', 'refund.approve', 'schedule.create', 'schedule.cancel', 'lesson.checkIn', 'lesson.consume', 'lesson.reverse', 'lesson.reverse.approve', 'feedback.publish', 'star.claim', 'star.review', 'star.rule.manage', 'mall.redeem', 'mall.item.manage', 'inventory.adjust', 'account.restore', 'account.disable', 'audit.read', 'export.sensitive'],
  super: [...actions],
};

export function can(role: Role, action: Action) {
  return grants[role].includes(action);
}

export function canAccessScope(role: Role, scope: DataScope) {
  return roleScopes[role].includes(scope);
}

export function assertPermission(role: Role, action: Action) {
  if (!can(role, action)) throw new Error(`权限不足：${role}不能执行${action}`);
}

export function canReviewActor(role: Role, reviewerId: string, actorId: string) {
  return (role === 'manager' || role === 'super') && reviewerId !== actorId;
}
